import { jsx as _jsx } from "react/jsx-runtime";
import { StyledHorizontalBarChart } from "./styled";
export const HorizontalBarChart = props => {
    return _jsx(StyledHorizontalBarChart, { ...props });
};
